export const SET_ATTENTION_TEXT = 'COMMONTEXTS_SET_ATTENTION_TEXT'
export const SET_ERROR_TEXT = 'COMMONTEXTS_SET_ERROR_TEXT'
export const SET_WARNING_TEXT = 'COMMONTEXTS_SET_WARNING_TEXT'
export const SET_EXTERNAL_LINK_TEXT = 'COMMONTEXTS_SET_EXTERNAL_LINK_TEXT'
export const SET_ERROR_LOGIN_USER_TEXT = 'COMMONTEXTS_SET_ERROR_LOGIN_USER_TEXT'
export const SET_COMMON_TEXTS = 'COMMONTEXTS_SET_COMMON_TEXTS'



// WEBPACK FOOTER //
// ./src/features/CommonTexts/data/constants.js